import { render, staticRenderFns } from "./Aftersale.vue?vue&type=template&id=45da8f84&"
import script from "./Aftersale.vue?vue&type=script&lang=js&"
export * from "./Aftersale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports